import * as React from 'react';
import { FC } from 'react';
import Intro from './Intro';
import Section from './Section';
import SideMenu from './SideMenu';

export type PageProps = {
  OverTitle?: string;
  Title?: string;
  UID?: string;
  Subtitle?: string;
  Info?: string;
  Notes?: string;
  Sections?: SectionDto[];
  Files?: FileRef[];
  ShowTitle?: boolean;
  type?: string;
};

type Props = PageProps;

const PanelPage: FC<Props> = (props) => {
  const { Sections, Files } = props;

  const sideMenu = <SideMenu sections={Sections} files={Files} />;

  return (
    <>
      <Intro {...props} />
      {Sections &&
        Sections.map((section, i) =>
          <Section
            key={section.UID}
            Online={section.Online}
            Title={section.Title}
            UID={section.UID}
            Panels={section.Panels}
          >
            {i === 0 && sideMenu}
          </Section>
        )}
    </>
  );
};

export default PanelPage;


// WEBPACK FOOTER //
// ./src/Components/PanelPage.tsx